export async function GetCroppedImg(imageSrc: string, crop: { x: number; y: number; width: number; height: number }): Promise<Blob> {
    const image = new Image();  
    image.src = imageSrc;
    
    await new Promise((resolve) => {
      image.onload = resolve;
    });
  
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
  
    if (!ctx) throw new Error("Canvas context not found");
  
    canvas.width = crop.width;
    canvas.height = crop.height;
  
    ctx.drawImage(
      image,
      crop.x, crop.y, crop.width, crop.height, // Source
      0, 0, crop.width, crop.height // Destination
    );
  
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) throw new Error("Failed to create blob from cropped image");
        resolve(blob);
      }, "image/png"); // You can change to "image/jpeg"
    });
  }
  